"use client";

import { enqueuePage } from "./analytics-event-queue";
import { getAnalyticsInstance } from "./get-analytics-instance";

function page(properties?: Record<string, unknown>): void {
  const analytics = getAnalyticsInstance({ eventType: "page" });
  if (!analytics) {
    return;
  }

  enqueuePage(analytics, properties);
}

export { page };
